import React, { useCallback, useEffect, useState } from 'react'
import CouponCard from './CouponCard/CouponCard'
import Input from './Forms/Input'
import Button from './Forms/Button'
import '../Fonts/Foco-Regular.ttf'
import stylesCpfForm from './CpfForm/CpfForm.module.css'
import useForm from '../Hooks/useForm'
import styles from './Home.module.css'
import Error from './Error/Error'
import { useLocation } from 'react-router-dom'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'

const Home = () => {
  const { executeRecaptcha } = useGoogleReCaptcha()

  const useRecaptchaEnterprise = process.env.REACT_APP_USE_RECAPTCHA_ENTERPRISE === 'true'

  const cpf = useForm('cpf', '')

  const isVisibleCoupons = useForm('', null)
  const isVerifyRecaptcha = useForm('', !useRecaptchaEnterprise)
  const loading = useForm('', false)

  const hasError = useForm('', false)
  const hasRecaptchaError = useForm('', false)
  const location = useLocation()
  const hash = new URLSearchParams(location.search).get('hash')

  const [data, setData] = useState([])
  const [subsidiary, setSubsidiary] = useState(null)
  const [recaptcha, setRecaptcha] = useState(null)

  const reCaptchaVerify = async () => {
    if (!useRecaptchaEnterprise) {
      isVerifyRecaptcha.setValue(true)
      hasRecaptchaError.setValue(false)
      setRecaptcha(Math.random().toString())
      return
    }

    if (!executeRecaptcha) {
      console.log('Execute recaptcha not yet available')
      return
    }

    const token = await executeRecaptcha('getcoupon')
    await verifyCallback(token)
  }

  const handleReCaptchaVerify = useCallback(reCaptchaVerify, [executeRecaptcha])

  const verifyCallback = async (response) => {
    try {
      const result = await verifyRecaptchaToken(response)
      const jsonResult = await result.json()
      setRecaptcha(response)
      isVerifyRecaptcha.setValue(jsonResult.valid)
      hasRecaptchaError.setValue(!jsonResult.valid)
    } catch (err) {
      console.log('Erro na validação do recapctha', err)
      isVerifyRecaptcha.setValue(false)
      hasRecaptchaError.setValue(true)
      setRecaptcha('')
    }
  }

  const verifyRecaptchaToken = (token) => {
    return fetch(`${process.env.REACT_APP_API_URL}/v1/recaptcha/verify`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'app-token': process.env.REACT_APP_API_TOKEN
      },
      body: JSON.stringify({ challenge: token })
    })
  }

  const requestCoupon = () => {
    const cpfNumbers = cpf.value.replace(/[^0-9]/g, '')
    const params = new URLSearchParams({
      cpfCustomer: cpfNumbers,
      subsidiary: hash
    })

    const url = `${process.env.REACT_APP_API_URL}/v1/recommendation?${params}`
    return fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'app-token': process.env.REACT_APP_API_TOKEN,
        'recaptcha-token': recaptcha
      }
    })
  }

  const requestAndParseCoupon = async () => {
    const response = await requestCoupon()
    if (!response.ok) {
      throw Error(response)
    }

    const json = await response.json()

    const hasResponse = json != null

    if (hasResponse && json.recommendation.length > 0) {
      hasError.setValue(false)
      isVisibleCoupons.setValue(true)
      setSubsidiary(json.subsidiary)
      setData([])
      setData(json.recommendation)
    } else {
      isVisibleCoupons.setValue(false)
      hasError.setValue(true)
    }

    return json
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    if (cpf.validate()) {
      loading.setValue(true)
      try {
        await reCaptchaVerify()
        if (!useRecaptchaEnterprise || isVerifyRecaptcha.value === true) {
          await requestAndParseCoupon()
        }
      } catch (error) {
        console.error('Erro ao carregar recomendação de cupons', error)
        isVisibleCoupons.setValue(false)
        hasError.setValue(true)
      }

      loading.setValue(false)
    } else {
      isVisibleCoupons.setValue(false)
    }
  }

  useEffect(() => {
    handleReCaptchaVerify()
  }, [executeRecaptcha])

  return (
    <>
      <section>
        <p className={stylesCpfForm.textCpf}>Digite o seu CPF para carregar seus cupons exclusivos</p>
        <form action="" onSubmit={handleSubmit}>
          <div className={stylesCpfForm.contentInput}>
            <Input label="CPF" type="text" name="cpf" {...cpf} />
          </div>
          <div className={stylesCpfForm.contentButton}>
            <Button loading={loading}>CARREGAR CUPONS</Button>
          </div>
        </form>
      </section>

      {isVisibleCoupons.value === true
        ? <div className={styles.column}>
          <h2 className={styles.titleCupons}>Cupons exclusivos para você na filial {subsidiary}.</h2>
          <article className={styles.article}>
            <div className={styles.containerCards}>
              {
              data.map((coupon, index) => (
                <CouponCard
                  key={index + coupon.title}
                  type={coupon.discountType}
                  description={coupon.description}
                  title={coupon.title}
                  rules={coupon.rules}
                  validated={coupon.expireDate}
                  discountPercentage={coupon.discountPercentage}
                  price={coupon.price}
                  bonusValue={coupon.bonusValue}
                  bonusPercentage={coupon.bonusPercentage}
                  detailedDescription={coupon.detailedDescription}
                  imageUrl={coupon.imageUrl}
                  imageHeaderUrl={coupon.imageHeaderUrl}
                  active={coupon.active}
                  cpf={cpf}
                  couponId={coupon.couponId}

                />
              ))}
            </div>
          </article>
        </div>
        : <></>
      }

      {
        hasError.value === true
          ? <div className={styles.errorColumn}><Error></Error></div>
          : <></>
      }

      {
        hasRecaptchaError.value === true
          ? <div className={styles.errorColumn}><Error message="Erro na validação do Recaptcha"></Error></div>
          : <></>
      }
    </>
  )
}

export default Home
